import { RESPONSE_STATUS, CLEAR_RESPONSE, GET_SCHEDULE_DATA } from './schedulePickupTypes'
export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_SCHEDULE_DATA:
            return {
                ...state,
                schedule_data: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
